export default () => ({
    category: '',
    experience: '',
    loading: false,
    region: '',

    init() {
        const params = new URLSearchParams(window.location.search);
        this.category = params.get('category') || '';
        this.experience = params.get('tag') || '';
        this.region = params.get('region') || '';
    },

    reloadPage() {
        this.loading = true;
        const params = new URLSearchParams({
            category: this.category,
            tag: this.experience,
            region: this.region,
        });
        window.location = `/?${params}`;
    },
});
